import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=5532aa58&scoped=true&functional=true"
import script from "./VButton.vue?vue&type=script&lang=js"
export * from "./VButton.vue?vue&type=script&lang=js"
import style0 from "./VButton.vue?vue&type=style&index=0&id=5532aa58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5532aa58",
  null
  
)

export default component.exports